import axios from  'axios';
import {setCatch} from '../utils/auth';

// import {message} from 'antd';

const baseURL = (val) =>{
    // console.log(val)
    const baseVal = {
        // 'development':'//wxapp.kuaipantech.com/TopDigital/index.php',
        // 'production':'//wxapp.kuaipantech.com/TopDigital/index.php',
        // 'development':'//api.awards.topdigitalworld.com/index.php',
        // 'production':'//api.awards.topdigitalworld.com/index.php',
        'development':'//2025.service.awards.tbifestival.com/index.php',
        'production':'//2025.service.awards.tbifestival.com/index.php',
    }
    return baseVal[val]
}

const http = axios.create({
    timeout:30000,
    baseURL:baseURL(process.env.NODE_ENV)
})

http.interceptors.request.use(config =>{
    // console.log('config---------------', config);

    config.headers['Content-Type'] = 'application/json';

    // let token = localStorage.getItem('token');
    // if(token) config.headers['Authorization'] = token;
    // if(token) config.headers['Authorization'] = `Bearer ${token}`;

    return config
}, err =>{
    return Promise.reject(err)
});

http.interceptors.response.use(res =>{
    if(res){
        // console.log('--------http-------------', res)
        if(res.data.c !== 0 && res.data.ecode === -99995){
            setCatch("token","");
            setCatch("name","");
            var u = window.location.href;
            if(u.indexOf("/judge") > 0){
                window.location.href = '/judge/#/login';//正式环境
            }
            else{
                window.location.href = '/#/login';//本地开发环境
            }
            // window.location.href = '/#/login';
            return res.data;
        }
        else{
            return res.data;
        }
    }
},err =>{
    return Promise.reject(err)
})

export default http;
